module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n8r5n1r-855be810cab4e962fd8e088e8cdac0a4.svg";